import careersBg from '../assets/images/hero-bg.jpg';
import { Button, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import socialMedia from "../assets/images/social-media.svg";
import designer from "../assets/images/designer.svg";
import intern from "../assets/images/intern.svg";

import { useState } from 'react';

import atoms from '../assets/images/atoms.svg';
import saturn from '../assets/images/saturn.svg';
import atom from '../assets/images/atom.svg';
import { submitCareerForm } from '../services/apiService';


import cultur from '../assets/images/cultur.svg';
import idea from '../assets/images/idea.svg';
import responsibilities from '../assets/images/responsibilities.svg';
import learning from '../assets/images/learning.svg';
import creativity from '../assets/images/creativity.svg';
import energy from '../assets/images/energy.svg';


const Careers = () => {
    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const [formDataError, setFormDataError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });


    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        resume: null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Validate file type and size
    const validateResumeFile = (file) => {
        if (!file) return "Resume file is required";

        // Check file type
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        const allowedExtensions = ['.pdf', '.doc', '.docx'];
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
            return "Invalid file type. Only PDF, DOC, and DOCX files are allowed.";
        }

        // Check file size (5MB = 5 * 1024 * 1024 bytes)
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (file.size > maxSize) {
            return "File size exceeds 5MB limit.";
        }

        return null; // No error
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = {};

        // Validate required fields
        if (!formData.name.trim()) errors.name = "Name is required";
        
        if (!formData.email.trim()) {
            errors.email = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            errors.email = "Invalid email format";
        }

        if (!formData.phone.trim()) {
            errors.phone = "Phone is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone must be 10 digits";
        }

        if (!formData.subject.trim()) errors.subject = "Job position is required";

        // Validate resume file
        const resumeError = validateResumeFile(formData.resume);
        if (resumeError) {
            errors.resume = resumeError;
        }

        setFormDataError(errors);

        if (Object.keys(errors).length > 0) return;

        setIsSubmitting(true);
        setSubmitMessage({ type: '', text: '' });

        try {
            const response = await submitCareerForm(formData);

            if (response.success) {
                setSubmitMessage({
                    type: 'success',
                    text: response.message || 'Thank you for your application! We have received your submission and will review it shortly.'
                });
                
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: '',
                    resume: null
                });
                setFormDataError({});
                
                // Reset file input
                const fileInput = document.getElementById('resumeUpload');
                if (fileInput) {
                    fileInput.value = '';
                }

                // Close modal after 2 seconds on success
                setTimeout(() => {
                    handleCloseModal();
                    setSubmitMessage({ type: '', text: '' });
                }, 2000);
            } else {
                // Handle API validation errors
                if (response.errors && Array.isArray(response.errors)) {
                    const apiErrors = {};
                    response.errors.forEach(error => {
                        if (error.toLowerCase().includes('name')) apiErrors.name = error;
                        else if (error.toLowerCase().includes('email')) apiErrors.email = error;
                        else if (error.toLowerCase().includes('phone')) apiErrors.phone = error;
                        else if (error.toLowerCase().includes('subject') || error.toLowerCase().includes('position')) apiErrors.subject = error;
                        else if (error.toLowerCase().includes('resume') || error.toLowerCase().includes('file')) apiErrors.resume = error;
                    });
                    setFormDataError(prev => ({ ...prev, ...apiErrors }));
                }
                
                setSubmitMessage({
                    type: 'error',
                    text: response.error || response.message || 'Failed to submit application. Please try again later.'
                });
            }
        } catch (error) {
            setSubmitMessage({
                type: 'error',
                text: 'An unexpected error occurred. Please try again later.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };



    return (
        <div>

            {/* Hero Section */}
            <div
                className="service-section-bg"
                style={{ backgroundImage: `url(${careersBg})` }}
            >
                <div className='service-overlay position-relative text-center'>
                    <h1 className='serive-page-title'>
                        <span className='outline-theme-text'>Join</span> the Crew
                    </h1>
                    <p className='text-white service-text-desc mt-3'>
                        If you’re passionate, curious, ambitious, and slightly <br className="d-md-block d-none"/>
                        obsessed with all things digital, you’ll fit right in.
                    </p>
                    <Button variant="theme" className='btn-rounded mt-3' onClick={handleOpenModal}>
                        <span className="fs-14 fw-500">Grab this Position</span>
                        <span className="arrow-icon">
                            <i className="fa-solid fa-arrow-right icon"></i>
                            <i className="fa-solid fa-arrow-right icon"></i>
                        </span>
                    </Button>
                </div>
            </div>

            {/* Why Work at AdRocket */}
            
                        <div className="position-relative">
                            <img src={atoms} alt='floating-icons' className='floating-icons right rotate' />
                            <img src={saturn} alt='floating-icons' className='floating-icons left bottom' />
            
            <Container className='mb-5 pb-5'>
                <h1 className="outline-text testimonials-section-title custom-size">
                    Why Work<br className="d-md-block d-none"/> at <span className='outline-theme-text'>AdRocket</span>
                </h1>

                <Row>
                    {[
                        { no: cultur, title: "Culture", desc: "A culture built on growth" },
                        { no: idea, title: "Ideas", desc: "A team that supports ideas" },
                        { no: responsibilities, title: "Responsibilities", desc: "Real responsibilities from day one" },
                        { no: learning, title: "Learning", desc: "Fast learning, fast execution" },
                        { no: creativity, title: "Creativity", desc: "Clients who challenge creativity" },
                        { no: energy, title: "High Energy", desc: "High-energy, no-politics workplace" }
                    ].map((item, i) => (
                        <Col lg={4} key={i}>
                            <div className='career-card'>
                                <img className='icon' src={item.no} alt={item.title} />
                                <div className='text-wrapper'>
                                    <h2>{item.title}</h2>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
</div>

           <div className="position-relative">
                            <img src={atom} alt='floating-icons' className='floating-icons right bottom' />
              
            {/* Open Positions */}
            <Container className='mb-5 pb-5'>
                <div className="text-center">
                    <span className='hero-sub-title'>We are Hiring</span>
                    <h1 className='hero-title mb-5 outline-text'>We Have Open Positions</h1>
                </div>
                <Row>
                    {[
                        { img: socialMedia, role: "Social Media Manager" },
                        { img: designer, role: "Designer" },
                        { img: intern, role: "Internships" }
                    ].map((job, i) => (
                        <Col lg={4} key={i}>
                            <div className="hiring-flip-card">
                                <div className="hiring-flip-card-inner">
                                    <div className='hiring-card hiring-flip-card-front d-flex align-items-center justify-content-center'>
                                        <div className='icon-design d-flex align-items-center justify-content-center'>
                                            <img src={job.img} alt={job.role} />
                                        </div>
                                        <h2 className='mt-4 text-white'>{job.role}</h2>
                                    </div>
                                    <div className='hiring-card hiring-flip-card-back d-flex flex-column align-items-center justify-content-center'>
                                        <h2 className='text-white mb-4'>Grab this position!</h2>
                                        <Button variant="theme" className='btn-rounded' onClick={handleOpenModal}>
                                            <span className="fs-14 fw-500">Apply Now</span>
                                            <span className="arrow-icon">
                                                <i className="fa-solid fa-check icon"></i>
                                                <i className="fa-solid fa-check icon"></i>
                                            </span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
</div>
            {/* Apply Modal */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                centered
                className="apply-modal"
                backdropClassName="glass-backdrop"
            >
                <Modal.Body className="p-0 contact-page modal-dark-bg" style={{ borderRadius: 20, overflow: 'hidden' }}>
                    <Row className="g-0">

                        <Col md={12} className="p-4">
                            <div>
                                <Button
                                    variant="link"
                                    className="ms-auto d-block text-white p-0"
                                    onClick={handleCloseModal}
                                    style={{ fontSize: "22px", textDecoration: "none" }}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </Button>
                            </div>

                            <h2 className="outline-text text-center pb-4 mt-0">Apply for Job in <span className='outline-theme-text'>AdRocket</span></h2>
                            <div className='contact-form-section' style={{ position: 'relative' }}>
                                {/* Loading Overlay */}
                                {isSubmitting && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 1000,
                                        borderRadius: '20px',
                                        backdropFilter: 'blur(2px)'
                                    }}>
                                        <div className="text-center">
                                            <i className="fa-solid fa-spinner fa-spin text-white" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                                            <p className="text-white fs-14 mb-0">Submitting your application...</p>
                                        </div>
                                    </div>
                                )}

                                <Form onSubmit={handleSubmit} className='contact-form'>
                                    <Row>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='name'
                                                    placeholder='Your Full Name'
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {formDataError.name && <p className="text-danger fs-13 mt-1 ms-2">{formDataError.name}</p>}
                                            </Form.Group>
                                        </Col>



                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='email'
                                                    name='email'
                                                    placeholder='Your Email'
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {formDataError.email && <p className="text-danger fs-13 mt-1 ms-2">{formDataError.email}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='tel'
                                                    name='phone'
                                                    placeholder='Your Phone'
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {formDataError.phone && <p className="text-danger fs-13 mt-1 ms-2">{formDataError.phone}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={6}>
                                            <Form.Group className='mb-4'>
                                                <Form.Control
                                                    type='text'
                                                    name='subject'
                                                    placeholder='Job Position / Role'
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    className='form-input'
                                                />
                                                {formDataError.subject && <p className="text-danger fs-13 mt-1 ms-2">{formDataError.subject}</p>}
                                            </Form.Group>
                                        </Col>

                                        <Col lg={12}>
                                            <label
                                                htmlFor="resumeUpload"
                                                className="text-white mb-1 form-input w-100"
                                                style={{ cursor: "pointer", opacity: 0.8 }}
                                            >
                                                Your Resume (Click to Upload)
                                            </label>

                                            {/* Hidden file input */}
                                            <Form.Control
                                                type="file"
                                                name="resume"
                                                id="resumeUpload"
                                                accept=".pdf,.doc,.docx"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) {
                                                        // Validate file immediately
                                                        const error = validateResumeFile(file);
                                                        if (error) {
                                                            setFormDataError(prev => ({ ...prev, resume: error }));
                                                            e.target.value = ''; // Clear invalid file
                                                        } else {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                resume: file
                                                            }));
                                                            setFormDataError(prev => {
                                                                const newErrors = { ...prev };
                                                                delete newErrors.resume;
                                                                return newErrors;
                                                            });
                                                        }
                                                    }
                                                }}
                                                style={{ display: "none" }}
                                            />
                                            {formDataError?.resume && <p className="text-danger fs-13 mt-1 ms-2">{formDataError.resume}</p>}


                                            {/* Selected File Preview Section */}
                                            {formData.resume && (
                                                <div className="m-3 p-3 border rounded custom-selected-file">
                                                    <p className="text-white fs-14 mb-2">
                                                        <span className='op'>Selected File:</span> <strong>{formData.resume.name}</strong>
                                                        <br />
                                                        <span className='op' style={{ fontSize: '12px', opacity: 0.7 }}>
                                                            Size: {(formData.resume.size / (1024 * 1024)).toFixed(2)} MB
                                                        </span>
                                                    </p>
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => {
                                                            setFormData(prev => ({ ...prev, resume: null }));
                                                            const fileInput = document.getElementById('resumeUpload');
                                                            if (fileInput) fileInput.value = '';
                                                            setFormDataError(prev => {
                                                                const newErrors = { ...prev };
                                                                delete newErrors.resume;
                                                                return newErrors;
                                                            });
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-x"></i>
                                                    </Button>
                                                </div>
                                            )}
                                        </Col>



                                    </Row>




                                    <Form.Group className='my-4'>
                                        <Form.Control
                                            as='textarea'
                                            rows={3}
                                            name='message'
                                            placeholder='About You'
                                            value={formData.message}
                                            onChange={handleChange}
                                            className='form-input'
                                        />
                                    </Form.Group>

                                    {/* Success/Error Message */}
                                    {submitMessage.text && (
                                        <div className={`mb-3 p-3 rounded ${submitMessage.type === 'success' ? 'text-success bg-success bg-opacity-10' : 'text-danger bg-danger bg-opacity-10'}`}>
                                            <p className="mb-0 fs-14">{submitMessage.text}</p>
                                        </div>
                                    )}

                                    <Button 
                                        variant='theme' 
                                        className='btn-rounded submit-btn mx-auto' 
                                        type='submit'
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className='fs-14 fw-500 me-2'>Submitting...</span>
                                                <i className="fa-solid fa-spinner fa-spin"></i>
                                            </>
                                        ) : (
                                            <>
                                                <span className='fs-14 fw-500'>Submit</span>
                                                <span className='arrow-icon'>
                                                    <i className="fa-regular fa-paper-plane icon"></i>
                                                    <i className="fa-regular fa-paper-plane icon"></i>
                                                </span>
                                            </>
                                        )}
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

        </div>
    );
};

export default Careers;
